import { Query } from '../Model/Query';
import { Parent } from '../Model/Parent';
export class ParentsService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(parentId) {
        if (parentId) {
            const response = await this.apiService.get('parent/' + parentId);
            if (!response.ok) {
                throw new Error(`Error al obtener el tercero.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ParentId.`);
        }
    }
    async findbyThird(thirdId) {
        if (thirdId) {
            const response = await this.apiService.get('parent/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener los Parents.`);
            }
            const content = await response.json();
            if (content) {
                return content.map(parent => new Parent(parent).getState());
                ;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener thirdId.`);
        }
    }
    async findParents(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`parents?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(parent => new Parent(parent).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveParent(parent) {
        if (parent) {
            const response = await this.apiService.post('parent', parent);
            if (!response.ok) {
                throw new Error(`Error al guardar el tercero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async removeParent(parent) {
        if (parent) {
            const response = await this.apiService.post('remove_parent', parent);
            if (!response.ok) {
                throw new Error(`Error al eliminar el tercero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
}
